import { builder } from "@builder.io/sdk";
import type { GetStaticPaths, GetStaticProps } from "next";

import { pagesModel } from "@/builder/model-names";
import {
  getPaths,
  type Page,
  parsePageParams,
  repeatUntilAllPagesFetched,
} from "@/builder/utils";
import { REVALIDATION_TIME_SECONDS } from "@/lib/constants";
import { StaticPage } from "@/modules/static-page/StaticPage";

interface PageProps {
  page: Page;
}

export default function Page(props: PageProps) {
  return <StaticPage page={props.page}></StaticPage>;
}

function getPreviewOptions() {
  return process.env.NODE_ENV === "development" ||
    process.env.VERCEL_ENV === "preview"
    ? { includeUnpublished: true, preview: true }
    : {};
}

const previewOptions = getPreviewOptions();

export const getStaticPaths = (async () => {
  const staticPages = await repeatUntilAllPagesFetched(async (options) => {
    return builder.getAll(pagesModel.page, {
      options: { noTargeting: true },
      fields: "data.url",
      ...previewOptions,
      ...options,
    });
  });

  const paths = getPaths(staticPages, new Set(["/thank-you-referral"]));

  return {
    paths,
    fallback: "blocking",
  };
}) satisfies GetStaticPaths;

export const getStaticProps = (async ({ params }) => {
  const pageParams = parsePageParams(params?.page);
  const staticPage = await builder
    .get(pagesModel.page, {
      url: `/${pageParams}`,
      query: {
        "data.url": { $ne: "/thank-you-referral" },
      },
      ...previewOptions,
    })
    .promise();

  return {
    props: {
      page: staticPage,
    },
    notFound: !staticPage,
    revalidate: REVALIDATION_TIME_SECONDS,
  };
}) satisfies GetStaticProps;
